/**
 * @author Tamara Bazko
 */
import StoreFinder from 'components/storeFinder/StoreFinder';
import Data from 'components/storeFinder/Data';
import GoogleMap from 'components/storeFinder/API/googleMap';
import GoogleMapSearch from 'components/storeFinder/API/googleMapSearch';
import GoogleDirections from 'components/storeFinder/API/googleDirections';
import baseInitialize from './base';

baseInitialize();

const settings = {
  mapApi: GoogleMap,
  mapSearchApi: GoogleMapSearch,
  directionsApi: GoogleDirections,
  Data,
};

StoreFinder.initialize(settings);
